/*
 *  -----------------------------------------------------------------------
 *    <copyright file="generated-reports-grid.interface.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { OpraReportTemplate, ReportModules } from '@interfaces/report-templates.interface';

export interface GeneratedReportsGridProps {
    orgKey: string;
    module: ReportModules;
    currentTemplate?: OpraReportTemplate;
    isGenerationHistory?: boolean;
}

export enum REPORTS_GRID_VIEWS {
    allReports = 'allReports',
    myReports = 'myReports',
}
